import { useEffect, useState } from "react";

import { toISO } from "../../lib/dateWindow";

/**
 * Today as `YYYY-MM-DD` in the viewer's day, kept current (#2640). A tab left
 * open overnight moves to the new day when the user returns to it: the value
 * is re-read on `focus` and when the page becomes visible again. The same
 * date gives the same state value, so an unchanged day renders nothing.
 */
export function useToday(): string {
  const [today, setToday] = useState(() => toISO(new Date()));
  useEffect(() => {
    const refresh = () => setToday(toISO(new Date()));
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
  return today;
}
